import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Listyear from "../Listyear";

import axios from "axios";
import { API_BASE_URL, DEFAULT_YEAR } from "../../config";

import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import Loader from "../loader/Loader";

import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const GalleryRacing = () => {
    const [dataGallery, setDataGallery] = useState([]);
    const [loading, setLoading] = useState(true);

    const count = useRef(0);
    const year = useRef(DEFAULT_YEAR);
    const totalPages = useRef(0);

    const fetchDataGallery = (selectYear, page_index) => {
        const params = {
            year: selectYear,
            page_index: page_index,
            page_size: 12,
        };
        const headers = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        axios
            .post(`${API_BASE_URL}hinhanh`, params, { headers })
            .then((response) => {
                setDataGallery(response.data);
                totalPages.current = Math.floor(response.data.countAll / 20);
            })
            .catch((err) => {
                console.log("Err", err);
            });
    };

    useEffect(() => {
        fetchDataGallery(year.current, 0);
    }, []);

    const handleNext = () => {
        setLoading(true);
        count.current += 1;
        fetchDataGallery(year.current, count.current);
    };

    const handlePrev = () => {
        if (count.current > 0) {
            setLoading(true);
            count.current -= 1;
        }
        fetchDataGallery(year.current, count.current);
    };
    const handleOnLoad = (index, total) => {
        if (index === total - 1) setLoading(false);
    };
    const handleGetYear = (data) => {
        year.current = data;
        count.current = 0;
        fetchDataGallery(data);
    };
    return (
        <Container>
            <div className="content-header flex">
                <div className="header-title --flex-center">Hình Ảnh</div>
                <Listyear getYearCallback={handleGetYear} />
            </div>
            <div className="wrapper-gallery">
                {count.current > 0 && (
                    <button className="btn-prev" onClick={handlePrev}>
                        <ArrowBackIosNewIcon
                            color="action"
                            sx={{ fontSize: 40 }}
                        />
                    </button>
                )}

                {count.current < totalPages.current && (
                    <button className="btn-next" onClick={handleNext}>
                        <ArrowForwardIosIcon
                            color="action"
                            sx={{ fontSize: 40 }}
                        />
                    </button>
                )}

                {!dataGallery.items ? (
                    <Loader />
                ) : (
                    <>
                        <div className="gallery-content">
                            <div className="show-list-image">
                                {dataGallery.items.map((item, index) => (
                                    <Zoom key={index} className="zoomcss">
                                        <img
                                            alt={item.tvh_mota}
                                            src={item.tvh_hinhanh}
                                            width="300"
                                            onLoad={() =>
                                                handleOnLoad(
                                                    index,
                                                    dataGallery.count
                                                )
                                            }
                                        />
                                    </Zoom>
                                ))}
                            </div>
                            {loading && (
                                <div className="cover-gallery">
                                    <div className="block-spiner"></div>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </div>
        </Container>
    );
};

const Container = styled.div`
    min-height: 691px;
    margin-top: 2rem;
    .content-header {
        background-color: var(--color-white);

        .header-title {
            font-size: 2.7rem;
            color: var(--color-header-title);
            width: 20rem;
        }
    }
    .wrapper-gallery {
        position: relative;
        .btn-prev {
            display: flex;
            position: absolute;
            top: 292px;
            left: 0;
            border: none;
            z-index: 1;
            opacity: 0.8;
            background-color: lightgray;
            cursor: pointer;
        }
        .btn-next {
            display: flex;
            position: absolute;
            top: 292px;
            right: 0;
            border: none;
            z-index: 1;
            opacity: 0.8;
            background-color: lightgray;
            cursor: pointer;
        }
        .gallery-content {
            position: absolute;
            .show-list-image {
                display: flex;
                gap: 5px;
                flex-flow: wrap;
                transition: all 250ms linear 2s;

                img {
                    gap: 10px;
                    /* width: 230px;
                    height: 150px; */
                    width: 288px;
                    height: 200px;
                    object-fit: cover;
                }
            }
            .cover-gallery {
                position: absolute;
                top: 0;
                width: 1170px;
                height: 631px;
                background: #dd6f20;
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 2;
                .block-spiner {
                    margin: auto;
                    border: 20px solid #eaf0f6;
                    border-radius: 50%;
                    border-top: 20px solid #ff7a59;
                    width: 200px;
                    height: 200px;
                    animation: spinner 4s linear infinite;
                }
            }
            @keyframes spinner {
                0% {
                    transform: rotate(0deg);
                }
                100% {
                    transform: rotate(360deg);
                }
            }
        }
    }

    @media only screen and (max-width: 767px) {
        .wrapper-gallery {
            .gallery-content {
                .show-list-image {
                    img {
                        width: 100%;
                    }
                }
                .cover-gallery {
                    .block-spiner {
                        width: 100px;
                        height: 100px;
                    }
                }
            }
        }
        [data-rmiz] {
            width: 49%;
        }
        .content-header {
            .header-title {
                font-size: 2rem;
            }
        }
    }
`;

export default GalleryRacing;
